module.exports = __webpack_public_path__ + "img/emergency-kit.56bcbc03.svg";